/*
    Copyright (C) 2023 - Wheel and Brake - Southwest Airlines
*/
import "./FieldValidation.css";
import { CloseButton } from "react-bootstrap";

const FieldValidation = (props) => {
  const type = props.type || "error";
  const show = props.show;
  const message = props.message;
  const onClose = props.onClose;
  const fieldName = props.fieldName;
  const effect = props.effect || "comment";
  const closeBtn = <span style={{ float: "right" }}>
    <CloseButton onClick={onClose} style={{ float: "right" }}>
      <span>X</span>
    </CloseButton>
  </span>

  return (
    <div className={`field-validation ${type || "info"} ${(show && "show") || ""}`}>
      {(!effect || effect === "inline") && (
        <span className="inline-message">{closeBtn}{message}</span>
      )}
      {effect === "tooltip" && (
        <div className="tooltip">
          !<span className="tooltip-message">{closeBtn}{message}</span>
        </div>
      )}
      {effect === "comment" && (
        <div id={fieldName} className="comment tooltip">
          <span className="tooltip-message">{closeBtn}{message}</span>
        </div>
      )}
    </div>
  );
};

export default FieldValidation;
